module.exports = __webpack_public_path__ + "img/ag.3ede4038.png";